import {
  Component,
  OnInit,
  Input,
  ElementRef,
  ViewChild,
  Renderer2,
  OnDestroy,
  AfterViewInit,
} from "@angular/core";
import { EventsService } from "src/app/services/event/event.service";
import { MobileDataService } from "src/app/services/mobile-data/mobile-data.service";
import { ConfigService } from "src/app/services/config/config.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { ScrollService } from "src/app/services/scroll/scroll.service";
import { Platform } from "@ionic/angular";
import { LobbyService } from "src/app/services/lobby/lobby.service";
import { Subscription } from "rxjs";
@Component({
  selector: "app-mobile-navbar",
  templateUrl: "./mobile-navbar.component.html",
  styleUrls: ["./mobile-navbar.component.scss"],
})
export class MobileNavbarComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() mobileLobby: string;
  @Input() defaultKeyword = true;
  @Input() selectedKeyword = "";
  @Input() clearStyles = false;
  @Input() scrollable = true;
  @ViewChild("topNavbar", { static: false }) topNavbar: ElementRef;

  public topSelectedItem = null;
  public bottomSelectedItem = null;
  public scrollSubscription: any;
  public cdn = "";
  public exemptions = ["raf"];
  public sticky = false;
  public isAuthenticated = false;
  public previousSticky = null;
  private subscr: Array<Subscription> = [];

  constructor(
    private mobileData: MobileDataService,
    private eventsService: EventsService,
    private userSession: UserSessionService,
    private config: ConfigService,
    private el: ElementRef,
    private renderer: Renderer2,
    private lobbyService: LobbyService,
    private platform: Platform,
    private scroll: ScrollService
  ) {
    this.cdn = this.config.getConfig().CDN_BASEURL;
    this.mobileData.getMobileLobbyKeyword().subscribe((keywordSubject) => {
      if (keywordSubject.topKeyword) {
        this.topSelectedItem = keywordSubject.topKeyword;
        this.bottomSelectedItem = null;
      }

      if (keywordSubject.bottomKeyword) {
        this.bottomSelectedItem = keywordSubject.bottomKeyword;
        this.topSelectedItem = null;
      }

      setTimeout(() => {
        this.scrollToActiveElement();
      }, 10);
    });
    this.verifyAuth();
    this.subscr.push(this.eventsService.subscribe("event:login", () => {
      this.verifyAuth();
    }));

    this.subscr.push(this.eventsService.subscribe('event:select:keyword:game:close', () => {
      if(this.lobbyService.getCurrentActiveKeywordItem()){
        setTimeout(() => {
          const bottomSelectTabList = ['Promotions'];
          const activeKeywordItem = this.lobbyService.getCurrentActiveKeywordItem();
          if (!activeKeywordItem?.name) {
            return;
          }
          const isBottomItem = bottomSelectTabList.includes(activeKeywordItem.name);
          if (this.platform.is('capacitor') && isBottomItem) {
            this.onBottomSelected(activeKeywordItem);
          } else {
            this.onTopSelected(activeKeywordItem);
          }        
        }, 400);
      }
    }));
  }

  ngAfterViewInit() {
    if (this.scrollable)
      this.scrollSubscription = this.scroll
        .getScrollPosition()
        .subscribe((element) => {
          this.checkScroll(element);
        });
  }
  checkScroll(element) {
    if (this.platform.is("ios")) {
      this.sticky =
        this.topNavbar?.nativeElement.offsetTop <= element.detail.scrollTop;
    } else {
      const newSticky =
        (this.topNavbar?.nativeElement.getBoundingClientRect().top || 1) <=
        element.detail.scrollTop;
      if (newSticky !== this.previousSticky) {
        this.sticky = newSticky;

        if (!this.sticky) {
          this.removeStickyClass();
        }
        this.previousSticky = newSticky;
      }
    }
  }
  removeStickyClass() {
    if (this.topNavbar?.nativeElement)
      this.renderer.removeClass(this.topNavbar.nativeElement, "sticky");
  }
  ngOnInit() {
    this.subscr.push(this.userSession.getUserStatus().subscribe(() => {
      this.topSelectedItem = null;
      this.bottomSelectedItem = null;
    }));

    this.subscr.push(this.eventsService.subscribe("event:config:reload", () => {
      this.topSelectedItem = null;
      this.bottomSelectedItem = null;
    }));
  }

  isModalPage(selectedItem) {
    return (
      selectedItem.action_type == "internalnav" &&
      !!this.exemptions.find((item) => item == selectedItem.action_param)
    );
  }
  onTopSelected(selectedItem) {
    selectedItem["isBottom"] = false;
    this.eventsService.publish("searchbar:keyword:click", selectedItem);
    this.lobbyService.setCurrentActiveKeywordItem(selectedItem);
    this.sendSelectedKeyword(selectedItem, {
      topKeyword: selectedItem.name,
      bottomKeyword: null,
    });
  }
  onBottomSelected(selectedItem) {
    selectedItem["isBottom"] = true;
    this.eventsService.publish("searchbar:keyword:click", selectedItem);
    this.sendSelectedKeyword(selectedItem, {
      topKeyword: null,
      bottomKeyword: selectedItem.name,
    });
  }
  scrollToActiveElement() {
    const activeElement =
      this.el.nativeElement.querySelector(".keywords-isactive");
    if (activeElement) {
      const container =
        this.el.nativeElement.querySelector(".mobile-top-navbar");
      const containerLeft = container.scrollLeft;
      const containerRight = containerLeft + container.clientWidth;
      const elementLeft = activeElement.offsetLeft;
      const elementRight = elementLeft + activeElement.clientWidth;
      const containerOffset = container.getBoundingClientRect().left;
      const elementLeftWithOffset = elementLeft - containerOffset;
      const elementRightWithOffset = elementRight - containerOffset;

      if (elementLeftWithOffset < containerLeft) {
        container.scrollLeft = elementLeftWithOffset;
      } else if (elementRightWithOffset > containerRight) {
        container.scrollLeft = elementRightWithOffset - container.clientWidth;
      }
    }
  }

  sendSelectedKeyword(selectedItem, selectedKeyword) {
    const showLivedealersBoneusPopover: boolean =
      this.isAuthenticated && selectedItem.action_param == "livedealer"
        ? true
        : false;
    if (!this.isModalPage(selectedItem) && !showLivedealersBoneusPopover) {
      this.mobileData.setMobileLobbyKeyword(selectedKeyword);
    }
  }

  verifyAuth() {
    this.userSession.isAuthenticated().then((isAuthenticated) => {
      this.isAuthenticated = isAuthenticated;
    });
  }
  ngOnDestroy() {
    this.removeStickyClass();
    if (this.scrollSubscription) this.scrollSubscription?.unsubscribe();
    this.subscr.forEach(s => s.unsubscribe());
  }
}
